import PatientFormContainer from "../../../Component/Patients/PatientForm/PatientForm"

const PatientForm = () => {
  return (
    <div className='page-body'>
      <PatientFormContainer />
    </div>
  )
}

export default PatientForm